"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Link = _interopRequireDefault(require("@material-ui/core/Link"));
var _LockOutlined = _interopRequireDefault(require("@material-ui/icons/LockOutlined"));
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _config = require("../config");
var _Link2 = require("react-platform-components/dist/Link/Link");
var _LanguageSwitcherForForms = require("react-platform-components/dist/LanguageSwitcher/LanguageSwitcherForForms");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SocialAuthButtons = null;
try {
  SocialAuthButtons = require('react-platform-social/dist/SocialAuth/SocialAuthButtons').default;
} catch (error) {
  console.warn('SocialAuthButtons not found');
}
var styles = function styles(theme) {
  return {
    '@global': {
      body: {
        backgroundColor: theme.palette.common.white
      }
    },
    paper: {
      marginTop: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    form: {
      width: '100%',
      // Fix IE 11 issue.
      marginTop: theme.spacing(1)
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
    container: {
      padding: '5px 40px',
      boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      marginTop: theme.spacing(8)
    }
  };
};
var Login = /*#__PURE__*/function (_React$Component) {
  _inherits(Login, _React$Component);
  var _super = _createSuper(Login);
  function Login() {
    _classCallCheck(this, Login);
    return _super.apply(this, arguments);
  }
  _createClass(Login, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        inProgress = _this$props.inProgress;
      var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      }(!window['safari'] || typeof safari !== 'undefined' && window['safari'].pushNotification);
      return /*#__PURE__*/_react.default.createElement(_Container.default, {
        component: "main",
        maxWidth: "xs",
        className: classes.container
      }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.paper
      }, _config.LOGO_PATH && _config.LOGO_LINK && _config.LOGO_LINK_URL ? /*#__PURE__*/_react.default.createElement(_Link2.Link, {
        to: _config.LOGO_LINK_URL,
        base: _config.BASE_URL
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _config.LOGO_PATH,
        alt: "Medialem",
        width: "220"
      })) : _config.LOGO_PATH && _config.LOGO_LINK ? /*#__PURE__*/_react.default.createElement(_Link2.Link, {
        to: "",
        base: _config.BASE_URL
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _config.LOGO_PATH,
        alt: "Medialem",
        width: "220"
      })) : /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: this.props.locale === _config.DEFAULT_LOCALE ? '/' : "/".concat(this.props.locale)
      }, _config.NAVBAR_LOGO_PATH ? /*#__PURE__*/_react.default.createElement("img", {
        src: _config.NAVBAR_LOGO_PATH,
        alt: "",
        width: "180"
      }) : /*#__PURE__*/_react.default.createElement(_Avatar.default, {
        className: classes.avatar
      }, /*#__PURE__*/_react.default.createElement(_LockOutlined.default, null))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "h1",
        variant: "h5",
        style: {
          marginTop: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Sign in",
        defaultMessage: "Sign in"
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12
      }, _config.DISPLAY_SAFARI_LOREM && isSafari && /*#__PURE__*/_react.default.createElement(_Typography.default, {
        color: "error"
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Oups il semblerait que vous utilisiez le navigateur Safari. Notre plateforme est optimis\xE9e pour les navigateurs Chrome et Firefox",
        defaultMessage: "Oups il semblerait que vous utilisiez le navigateur Safari. Notre plateforme est optimis\xE9e pour les navigateurs Chrome et Firefox"
      }))), /*#__PURE__*/_react.default.createElement(_formik.Formik, {
        initialValues: {
          email: '',
          password: '',
          remember_me: false
        },
        onSubmit: function onSubmit(values) {
          _this.props.dispatch({
            type: 'LOGIN_USER',
            data: values,
            history: _this.props.history
          });
        }
      }, function (props) {
        return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("form", {
          className: classes.form,
          noValidate: true,
          onSubmit: props.handleSubmit
        }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
          variant: "outlined",
          margin: "normal",
          required: true,
          fullWidth: true,
          id: "email",
          label: "Email Address",
          name: "email",
          autoComplete: "email",
          autoFocus: true,
          validate: [(0, _formValidators.required)(), (0, _formValidators.email)()]
        }), /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
          variant: "outlined",
          margin: "normal",
          required: true,
          fullWidth: true,
          name: "password",
          label: "Password",
          type: "password",
          id: "password",
          autoComplete: "current-password",
          validate: ((0, _formValidators.required)(), (0, _formValidators.min)(6, 'Le mot de passe doit contenir au moins 6 caractères'))
        }), /*#__PURE__*/_react.default.createElement(_formFields.Checkbox, {
          name: "remember_me",
          label: "Remember me"
        }), /*#__PURE__*/_react.default.createElement(_Button.default, {
          type: "submit",
          fullWidth: true,
          variant: "contained",
          color: "primary",
          className: classes.submit,
          disabled: inProgress
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Sign In",
          defaultMessage: "Sign In"
        })), SocialAuthButtons && /*#__PURE__*/_react.default.createElement(SocialAuthButtons, null), /*#__PURE__*/_react.default.createElement(_Grid.default, {
          container: true
        }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          xs: true
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: "/reset",
          variant: "body2"
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Forgot password?",
          defaultMessage: "Forgot password?"
        }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: _config.REGISTER_FORM_URL,
          variant: "body2"
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Don't have an account? Sign Up",
          defaultMessage: "Don't have an account? Sign Up"
        }))))));
      })), /*#__PURE__*/_react.default.createElement(_Box.default, {
        mt: 5
      }), /*#__PURE__*/_react.default.createElement(_LanguageSwitcherForForms.LanguageSwitcher, null));
    }
  }]);
  return Login;
}(_react.default.Component);
var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})((0, _reactRedux.connect)(function (state) {
  return {
    inProgress: state.loginReducer.inProgress,
    locale: state.localeReducer.locale
  };
})(Login));
exports.default = _default;